import React, { useState } from "react";
import "./ContactPage.scss";
import Form from "../../Components/Form/Form";
import InputField from "../../Components/InputField/InputField";
import Button from "../../Components/Button/Button";
import emailjs from "emailjs-com";

const ContactPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [showLoading, setShowLoading] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    setShowLoading(true);
    await emailjs.send(
      "service_7g5ssci",
      "template_b2bt5or",
      {
        from_name: name,
        subject: subject,
        reply_to: email,
        message: message,
      },
      "user_Jk6t9OgdTMGprCKQk3EHk"
    );
    setShowLoading(false);
    alert("YOUR EMAIL HAS BEEN SENT. WE WILL RESPOND YOU ASAP.");
  };

  return (
    <div className="ContactPage">
      <h1>Get In Touch</h1>
      <p className="p">
        We Love to hear from you. Please fill below Details to get in touch with
        us.
      </p>

      <Form onSubmit={send}>
        <InputField
          value={name}
          onChange={(e) => setName(e.target.value)}
          black
          type="text"
          placeholder="Name"
          required
        />
        <InputField
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          black
          type="email"
          placeholder="Email"
          required
        />
        <InputField
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          black
          type="text"
          placeholder="Subject"
          required
        />
        <InputField
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          black
          type="text"
          placeholder="Message"
          required
          textarea
        />
        <Button showLoading={showLoading} black isSubmit text="Send" />
      </Form>
    </div>
  );
};

export default ContactPage;
